import React, { useState, useRef } from 'react';
import { useInView } from '../hooks';
import Button from './Button';

const SERVICES = [
  {
    icon: '/icon/airbnb.png',
    title: 'Airbnb & Short Let Cleaning',
    desc: 'Fast, reliable turnovers between guests. We ensure your property is guest-ready with hotel-level presentation every time.',
  },
  {
    icon: '/icon/deal.png',
    title: 'End of Tenancy Cleaning',
    desc: 'Thorough, deep-cleaning service designed to meet landlord and agency standards — helping you reclaim your full deposit.',
  },
  {
    icon: '/icon/cleaning.png',
    title: 'Residential Cleaning',
    desc: 'Regular domestic cleaning tailored to your schedule and preferences. Weekly, bi-weekly, or one-off cleans available.',
  },
];

function ServiceCard({ icon, title, desc, delay }) {
  const [hovered, setHovered] = useState(false);
  const ref = useRef(null);
  const inView = useInView(ref, 0.2);

  return (
    <div ref={ref}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: 'var(--cream)',
        border: `1.5px solid ${hovered ? 'var(--sky)' : 'var(--border)'}`,
        borderRadius: 20, padding: '36px 28px', textAlign: 'left',
        transition: 'transform 0.25s, box-shadow 0.25s, border-color 0.25s, opacity 0.6s',
        transform: inView ? (hovered ? 'translateY(-6px)' : 'translateY(0)') : 'translateY(20px)',
        boxShadow: hovered ? '0 20px 50px rgba(26,75,140,0.10)' : 'none',
        opacity: inView ? 1 : 0,
        transitionDelay: inView ? `${delay}ms` : '0ms',
        cursor: 'default',
      }}>

      <img
        src={icon}
        alt={title}
        style={{
          width: 58, height: 58,
          objectFit: 'contain',
          marginBottom: 20,
          transition: 'transform 0.25s',
          transform: hovered ? 'scale(1.08) rotate(-3deg)' : 'scale(1)',
        }}
      />

      <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.15rem', color: 'var(--navy)', marginBottom: 10 }}>{title}</h3>
      <p style={{ color: 'var(--muted)', fontSize: '0.88rem', lineHeight: 1.65 }}>{desc}</p>
    </div>
  );
}

export default function Services() {
  const ref = useRef(null);
  const inView = useInView(ref);

  return (
    <section id="services" style={{ padding: '100px 5%', background: '#fff', textAlign: 'center' }}>
      <div ref={ref} style={{
        maxWidth: 560, margin: '0 auto 60px',
        opacity: inView ? 1 : 0, transform: inView ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 0.6s, transform 0.6s',
      }}>
        <div style={{ fontSize: '0.78rem', fontWeight: 600, letterSpacing: '2.5px', textTransform: 'uppercase', color: 'var(--orange)', marginBottom: 12 }}>Our Services</div>
        <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 'clamp(1.7rem, 3.5vw, 2.4rem)', color: 'var(--navy)', lineHeight: 1.25, marginBottom: 14 }}>
          Comprehensive Cleaning Solutions
        </h2>
        <p style={{ color: 'var(--muted)', fontSize: '0.97rem', lineHeight: 1.7 }}>
          From Airbnb turnovers to deep end-of-tenancy cleans, we cover every corner of your property to the highest standard.
        </p>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 28, maxWidth: 1100, margin: '0 auto 48px' }}>
        {SERVICES.map((s, i) => <ServiceCard key={s.title} {...s} delay={i * 120} />)}
      </div>

      <Button href="#contact">Book a Service →</Button>
    </section>
  );
}